import { LogOut } from "lucide-react";
import { BNTLogo } from "@/pages/layoutChrome";
import { Button } from "@/components/ui/button";
import SatDownloadJobsIndicator from "@/components/sat/SatDownloadJobsIndicator";

/**
 * Barra superior del Panel General — logo, sesión y cerrar sesión.
 * Layout responsive: en pantallas estrechas las acciones pasan a segunda línea sin empalmar.
 */
export default function PanelHubTopbar({ ownerProfile, user, onLogout }) {
  const customLogo = (ownerProfile?.logo_base64 || "").trim();
  const customName = (ownerProfile?.nombre_comercial || ownerProfile?.razon_social || "").trim();
  const customSubtitle = (ownerProfile?.rfc || "").trim();

  return (
    <div
      className="sticky top-0 z-30 flex flex-col gap-3 border-b border-slate-200 bg-white px-4 py-3 shadow-sm shrink-0 sm:flex-row sm:items-center sm:justify-between sm:gap-4 sm:px-8 sm:py-4"
      data-testid="panel-hub-topbar"
    >
      <div className="min-w-0 flex-1 overflow-visible sm:flex-initial sm:max-w-[min(100%,36rem)]">
        <BNTLogo
          size="sm"
          customLogo={customLogo}
          customName={customName}
          customSubtitle={customSubtitle}
        />
      </div>
      <div
        className="flex w-full min-w-0 flex-wrap items-center justify-end gap-2 sm:w-auto sm:max-w-[min(100%,36rem)] sm:gap-3 lg:max-w-none"
        data-testid="panel-hub-topbar-actions"
      >
        <SatDownloadJobsIndicator />
        <div className="hidden min-w-0 max-w-[11rem] text-right md:block">
          <div className="text-xs text-slate-500">Sesión</div>
          <div
            className="truncate text-sm font-medium text-[#0F2D5C]"
            data-testid="current-user-name"
            title={user?.name || ""}
          >
            {user?.name}
          </div>
        </div>
        <Button
          data-testid="logout-btn"
          onClick={onLogout}
          variant="outline"
          className="shrink-0 whitespace-nowrap rounded-sm border-[#0F2D5C]/20 text-[#0F2D5C] hover:bg-slate-50"
          title="Cierra la sesión actual."
        >
          <LogOut className="mr-2 h-4 w-4 shrink-0" /> Cerrar sesión
        </Button>
      </div>
    </div>
  );
}
